import FilesPanel from './FilesPanel';
import './FilesPanel.scss';
import { getFilesPanelSchema, getFilesPanelAdminSchema } from './filesPanelSchema';

export { FilesPanel, getFilesPanelSchema, getFilesPanelAdminSchema };
